<template>
  <div class="modal--addScopes">
    <div class="modalCustom__header">
      <h5 class="">{{ data.header }}</h5>
      <hr class="modalCustom__header-border" />
    </div>

    <div class="modalCustom__body">
      <div v-if="scopes">
        <p>
          {{ $t('For_the_role') }}: <span class="text-primary text-title">{{ data.for_obj.name }}</span>
        </p>

        <!-- Select Part -->
        <div class="pt-4">
          <multiselect
            v-model="selected_scopes"
            :options="scopes"
            :multiple="true"
            group-values="options"
            group-label="group"
            :group-select="true"
            placeholder="Type to search"
            track-by="scope_id"
            :close-on-select="false"
            label="name"
          >
            <template slot="option" slot-scope="props">
              <div class="option">
                <span>{{ props.option.$groupLabel }}</span>
                <div class="flex flex-column">
                  <span class="option__title">{{ props.option.name }}</span>
                  <span class="option__small">{{ props.option.description }}</span>
                </div>
              </div>
            </template>
            <span slot="noResult">Oops! No elements found. Consider changing the search query.</span>
          </multiselect>
        </div>
        <!-- End Select Part -->
      </div>
      <div v-else>
        <p>
          <span class="text-custom_red">{{ data.for_obj.name }}</span> {{ $t('has_already_all_scopes') }}
        </p>
      </div>
    </div>

    <div class="modalCustom__footer">
      <!--            buttons                   -->
      <div class="mr-3">
        <p-button type="danger" round @click.native.prevent="closeModal">
          {{ $t('Cancel') }}
        </p-button>
      </div>
      <div>
        <p-button type="success" round @click.native.prevent="addScopes">
          {{ $t('save') }}
        </p-button>
      </div>
    </div>
  </div>
</template>

<script>
import CreateNewButton from '../buttons/CreateNewButton';
import CancelButton from '../buttons/CancelButton';
import SaveButton from '../buttons/SaveButton';
import Multiselect from 'vue-multiselect';
import GroupScopesController from '@/controllers/Scopes/GroupScopesController';
export default {
  name: 'AddScopesModal',
  components: { SaveButton, CancelButton, CreateNewButton, Multiselect },
  props: {
    data: {},
    for_obj: null,
  },
  data: function () {
    return {
      selected_scopes: null,
      scopes: this.$store.getters.userScopesCollection,
    };
  },
  mounted() {
    this.groupScopes();
  },
  methods: {
    closeModal: function () {
      this.selected_scopes = null;
      this.$emit('close');
    },
    addScopes: function () {
      this.$emit('submit', this.selected_scopes);
      this.closeModal();
    },
    groupScopes() {
      this.scopes = GroupScopesController.groupScopes(this.scopes);
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped></style>
